import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import pathname from '../../constants/pathname'
import AppContext from '../../context/AppContext'
import { getAllProject, searchAllProject } from '../../redux/actions/dashboard'
import './styles.less'
import TableAllProject from '../tableAllProject/TableAllProject'
import DashboradToggle from './DashboradToggle'
import TableLoadingTemplate from '../../widgets/loadingTemplate/tableLoadingTemplate/TableLoadingTemplate'
import { useDispatch } from 'react-redux'

export default function AllProject({ config, onSettingChange = () => {} }) {
  const contextValue = React.useContext(AppContext)
  const history = useHistory()
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [loading, setloading] = useState(false)
  const dispatch = useDispatch()

  useEffect(() => {
    if (config) {
      setSchema(settingSchema)
    } else {
      handelGetSchemaDashboard()
    }
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    try {
      const response = await getAllProject(5, 1)
      // console.log('res xxx => ', response)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    setIsLoading(false)
  }

  const handleSearchProject = async (
    pagesize,
    pagenumber,
    projectcode,
    projectname,
    contractNo,
    projectStatus,
    projectDepartment,
    showMyProject
  ) => {
    // startLoading()
    // console.log('showMyProject ', showMyProject)
    setloading(true)
    try {
      console.log('88800 ', projectStatus, projectDepartment)
      const status = projectStatus ? projectStatus.toString() : ''
      const department = projectDepartment ? projectDepartment.toString() : ''

      const response = await searchAllProject(
        pagesize,
        pagenumber,
        projectcode,
        projectname,
        contractNo,
        status,
        department,
        showMyProject
      )

      console.log('response ', response)

      if (response) {
        setSchema(response)
      }
    } catch (e) {
      console.log('e', e)
    }
    setloading(false)
    // doneLoading()
  }

  const onMutiSubmit = (selectList) => {
    // console.log('WaitForScrutinize onSubmit', selectList)

    let idList = selectList.map((element) => {
      return element.id
    })

    sessionStorage.setItem('mutiReview', idList)
    sessionStorage.setItem('projectId', 'multi-reveiw')
    sessionStorage.setItem('param', '')

    return history.push({
      pathname: `${pathname.proposal.review.projectList}`,
      state: { selectId: idList },
    })
  }

  const onSingleSubmit = (id) => {
    sessionStorage.setItem('projectId', id)
    sessionStorage.setItem('param', '')

    history.push(`${pathname.proposal.overview.overviewCoworker}`)
    // history.push(`${pathname.proposal.overview.overviewCoworker}/${obj.id}`)
  }

  if (!schema) {
    return <TableLoadingTemplate />
  }

  return (
    <>
      {schema && (
        <>
          {config && (
            <DashboradToggle
              onChange={onSettingChange}
              dashboradName={config.key}
              checked={config.show}
              style={{ marginTop: 20, marginBottom: -15 }}
            />
          )}
          <TableAllProject
            schema={schema}
            subName={{ enable: true }}
            muti={{ enable: false, buttonText: `ไปยังการ${schema?.mutiButtonText || 'กลั่นกรอง'}` }}
            single={{
              enable: true,
              buttonText: schema?.buttonText || 'กลั่นกรอง',
              icon: schema?.singleIcon,
            }}
            onSingleSubmit={onSingleSubmit}
            onMutiSubmit={onMutiSubmit}
            pagination={true}
            onReload={handleSearchProject}
            loading={loading}
            hiddenColStatus={true}
            searchRows={{
              enable: true,
              enableContract: true,
              enableProjectStatus: true,
              enableProjectdepartment: true,
              enableToggle: true,
            }}
            onSearchProject={handleSearchProject}
            showContractNo={true}
            setting={config && true}
          />
        </>
      )}
    </>
  )
}

const settingSchema = {
  header: 'โครงการทั้งหมด',
  projectCodeText: 'รหัสโครงการ',
  projectStatusOption: {
    name: 'projectStatusOption',
    label: 'สถานะโครงการ',
    value: null,
    disabled: false,
    options: [],
  },
  departmentOption: {
    name: 'projectDepartment',
    label: 'สำนัก',
    value: null,
    disabled: true,
    options: [],
  },
  showMyProject: {
    name: 'showMyProject',
    label: 'แสดงเฉพาะโครงการของฉัน',
    value: null,
    disabled: true,
  },
  projectNameText: 'ชื่อโครงการ',
  projectTypeText: 'ประเภทโครงการ',
  projectStatusText: 'สถานะ',
  projectEditVerText: 'แก้ไขล่าสุด',
  totalSize: 1,
  values: [
    {
      projectVersionId: 'XXX',
      code: 'XX-XXXXX',
      type: {
        icon: 'file-o',
        label: 'โครงการ',
      },
      projectName: {
        name: 'โครงการ XXX',
        statusName: 'XXX',
      },
      status: 'XXX',
      colorstatus: {
        code: '#9AB7D3',
        label: 'XXX',
      },
      date: 'XXX',
      contractNo: 'XX-XX-XXXX',
    },
  ],
}
